import { IsIn, IsOptional, IsString, MaxLength } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { RECALL_LOT_OUTCOMES, type RecallLotOutcome } from './recall.enums';

export class RecallLotOutcomeDto {
  @IsIn(RECALL_LOT_OUTCOMES)
  outcome!: RecallLotOutcome;

  @IsString()
  @IsOptional()
  @MaxLength(2000)
  @OptionalStringTransform()
  outcomeNotes?: string;
}
